export default __webpack_public_path__ + "static/media/Jacinda 9781408362969.7cf601e3.jpg";